class NewsletterPopup extends ModalDialog {
  constructor() {
    super();
    this.init();
    this.attachEventListeners();
  }

  // Moved all event listeners to a separate method for better organization
  attachEventListeners() {
    this.querySelectorAll(".js-button-close").forEach((btn) => {
      btn.addEventListener("click", this.closeNewsletter.bind(this));
    });

    if (this.form) {
      this.form.addEventListener("submit", this.onSubscribe.bind(this));
    }
  }

  init() {
    this.delay = this.dataset.delay * 1000;
    this.closed = getCookie("newsletter-closed");
    this.subscribed = getCookie("newsletter-subscribed");
    this.form = this.querySelector(".js-form");
    this.ageVerificationPopup = document.querySelector("age-verification-popup");
  }

  closeNewsletter() {
    setCookie("newsletter-closed", "true");
    this.hide();
    // Clean up URL params after closing confirmation
    if (window.location.search.includes("customer_posted=true")) {
      const url = new URL(window.location);
      url.searchParams.delete("customer_posted");
      url.hash = "";
      window.history.replaceState({}, "", url.pathname + url.search);
    }
  }

  connectedCallback() {
    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === "true") {
      this.show();
      }
      return;
    }

    // Check if returning from a successful newsletter signup
    if (this.isPostSignup()) {
      this.showConfirmation();
      return;
    }

    this.handlePopupVisibility();
  }

  isPostSignup() {
    const params = new URLSearchParams(window.location.search);
    return params.get("customer_posted") === "true";
  }

  showConfirmation() {
    setCookie("newsletter-subscribed", "true");
    const wrapper = this.querySelector(".newsletter-popup__wrapper");
    const confirmation = this.querySelector(".newsletter-popup__confirmation");
    if (wrapper && confirmation) {
      wrapper.classList.add("hidden");
      confirmation.classList.remove("hidden");
    }
    this.show();
  }

  handlePopupVisibility() {
    if (getCookie("age-verified") !== "true" && this.ageVerificationPopup) {
      this.handleAgeVerificationPopup();
    } else {
      this.showPopupWithDelay();
    }
  }

  handleAgeVerificationPopup() {
    let prevClassState = this.classList.contains("newsletter-popup-is-hidden");

    const observer = new MutationObserver(mutations => {
      const mutation = mutations[0];
      if (mutation.attributeName !== "class") return;

      const currentClassState = mutation.target.classList.contains("newsletter-popup-is-hidden");

      if (prevClassState !== currentClassState) {
        prevClassState = currentClassState;
        if (!currentClassState) {
          this.showPopupWithDelay();
        }
      }
    });

    observer.observe(this, { attributes: true });
  }

  showPopupWithDelay() {
    setTimeout(() => {
      if (this.closed !== "true" && this.subscribed !== "true") {
        this.show();
      }
    }, this.delay);
  }

  onSubscribe() {
    setCookie("newsletter-subscribed", "true");
  }
}

customElements.define("newsletter-popup", NewsletterPopup);
